import React, { memo } from 'react';
import { ObjectModel } from '@types';
import { ViewerThumb } from '../viewer-thumb';

import styles from '../viewer-window.module.scss';

interface NonCadViewerProps {
    model: ObjectModel;
}

export const NonCadViewer = memo<NonCadViewerProps>(
    ({ model }) => {
        return (
            <div className={styles.box}>
                <div className={styles.inner}>
                    <ViewerThumb
                        thumb={model.thumb}
                        smallThumb={model.thumb_300x300}
                        thumbStatus={model.thumb_status}
                        show
                        expanded={false}
                    />
                </div>
            </div>
        );
    },
    (prev, next) => {
        return prev.model.id === next.model.id;
    },
);
